import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, DialogContent, Grid, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ItemPhoto from '../../atoms/ItemPhoto';
import { resizeImage } from '../../../utils';
import useMediaQueries from '../../../hooks/useMediaQueries';
;
const DialogZoomedPhoto = ({ imageUrl = '', alt = '', isOpen = false, handleZoomClose, maxZoomWidth = 'xl', }) => {
    const { fitForDesktop, } = useMediaQueries();
    return (_jsx(Dialog, { open: isOpen, onClose: handleZoomClose, maxWidth: fitForDesktop ? maxZoomWidth : false, fullWidth: fitForDesktop, fullScreen: !fitForDesktop, children: _jsxs(DialogContent, { sx: {
                display: 'flex',
                flexDirection: 'column',
                p: '0 16px 16px',
                minHeight: '80vh',
            }, onClick: event => event.stopPropagation(), children: [_jsx(Grid, { item: true, container: true, justifyContent: 'flex-end', py: 1, children: _jsx(IconButton, { onClick: handleZoomClose, children: _jsx(CloseIcon, { sx: { fontSize: '48px' }, color: 'action' }) }) }), _jsx(ItemPhoto, { imageUrl: resizeImage(imageUrl, 2000), alt: alt, size: {
                        image: '100%',
                        icon: 'large',
                    }, sx: { flex: 1 }, isZoomable: false, showWhenNoPhotoAvailable: true })] }) }));
};
export default DialogZoomedPhoto;
//# sourceMappingURL=index.js.map